import React, { useContext, useMemo, useState } from 'react';
import { useActiveDBCollectionQuery } from '../../../../../../Components/QueryComponents/ActiveDBCollectionQuery/ActiveDBCollectionQuery';
import ServerError from '../../../../../../Components/ServerError/ServerError';
import { getEmptyUrval } from '../../../../../../Components/Urval/Utils/urvalUtils';
import { findCollectionStatic } from '../../../../../../Model/avenyStaticModelUtils';
import { TSelectedDetail } from '../../../../../../Types/MasterDetailTypes';
import { IUIUrval } from '../../../../../../Types/UrvalTypes';
import { IFilterAttribute } from '../../../Const/Delsystem';
import defaultColumns from '../../../Utils/defaultColumns';
import { IAssociationListConfig } from '../AssociationList/AssociationList';
import { EnhancedAssociationListMaster as AssociationListMaster } from '../AssociationList/AssociationListMaster';
import { BusinessDataFormContext } from '../BusinessDataForm/BusinessDataForm';
import {
  VisningsTypContext,
  VisningsTypContextProvider,
} from '../VisningsTypContext/VisningsTypContext';
import { GridEventListener } from '@mui/x-data-grid-pro';
import { equals } from 'ramda';
import { addAllDataDependencies } from '../../../Const/BusinessConfigs';

interface IProps {
  collectionName: string;
  disableStartWithEmptyUrval?: boolean;
  urval?: IUIUrval;
  urvalId?: string | undefined;
  config?: IAssociationListConfig;
  onRowClick?: GridEventListener<'rowClick'>;
  selectDetail?: (id: TSelectedDetail) => void;
  selectedId?: TSelectedDetail;
  selectionGrid?: boolean;
  filterAttributes?: IFilterAttribute[];
  onCompleted?: ((data: any) => void) | undefined;
}

const CollectionList: React.FC<React.PropsWithChildren<IProps>> = props => {
  const businessDataFormContext = useContext(BusinessDataFormContext);
  const { rutinId } = useContext(VisningsTypContext);
  const [searchText, setSearchText] = useState('');

  const collection = findCollectionStatic(props.collectionName);

  const [columns, setColumns] = useState(
    props.config?.customDefaultColumns || defaultColumns(props.collectionName)
  );

  const [urval, setUrval] = useState(
    props.urval ?? (props.disableStartWithEmptyUrval ? null : getEmptyUrval())
  );

  const attributeDefs = useMemo(
    () =>
      addAllDataDependencies(
        props.collectionName,
        columns,
        undefined,
        props.config?.customBusinessConfig
      ),
    [columns, props.collectionName, props.config?.customBusinessConfig]
  );

  const { data, loading, serverError, refetch } = useActiveDBCollectionQuery({
    collectionName: props.collectionName,
    attributeDefs: attributeDefs,
    urval: urval,
    urvalId: props.urvalId,
    onCompleted: props.onCompleted,
  });

  if (props.urval && !equals(urval, props.urval)) {
    setUrval(props.urval);
  }

  if (!collection) {
    return null;
  }

  if (serverError) {
    <ServerError error={serverError} />;
  }

  return (
    <VisningsTypContextProvider
      rutinID={rutinId}
      collectionName={props.collectionName}
      inCard={props.config?.inCard}
      defaultVisningstyp={props.config?.defaultVisningstyp}
    >
      <AssociationListMaster
        associatedCollection={collection}
        association={undefined}
        ownId={null}
        onRowClick={props.onRowClick}
        collectionName={collection.CollectionName}
        columns={columns}
        setColumns={setColumns}
        data={data}
        newItems={undefined}
        loading={loading}
        refetch={refetch}
        selectDetail={props.selectDetail ?? (() => {})}
        selectedId={props.selectedId ?? null}
        selectionGrid={props.selectionGrid}
        config={props.config ?? {}}
        baseCollection={collection}
        baseId={null}
        detaljurval={urval}
        setDetaljurval={setUrval}
        editable={
          props.config?.integrated &&
          businessDataFormContext?.formState.editMode
        }
        searchText={searchText}
        setSearchText={setSearchText}
        filterAttributes={props.filterAttributes}
      />
    </VisningsTypContextProvider>
  );
};

export default CollectionList;
